export default __webpack_public_path__ + "static/media/activity-medication-icon.2bd342a0.svg";